import React from 'react';
import classNames from 'classnames';

import css from './IconDropdownArrow.module.css';

/**
 * Add icon: "+"
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own root class
 * @param {string?} props.rootClassName overwrite components own root class
 * @returns {JSX.Element} "add" icon
 */
const IconDropdownArrow = props => {
  const { className, rootClassName, isClicked } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg className={classes} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path fillRule="evenodd" clipRule="evenodd"
        d={isClicked ? "M10.5499 6.26324C10.245 5.91232 9.75501 5.91232 9.45013 6.26324L3.22808 13.4629C2.92397 13.8157 2.92397 14.3844 3.22808 14.7354C3.5314 15.0882 4.02372 15.0882 4.32782 14.7354L10 8.17293L15.6722 14.7354C15.9755 15.0882 16.4678 15.0882 16.7719 14.7354C17.076 14.3844 17.076 13.8157 16.7719 13.4629L10.5499 6.26324Z" : "M9.45013 13.7368C9.75501 14.0877 10.245 14.0877 10.5499 13.7368L16.7719 6.53712C17.076 6.18434 17.076 5.61557 16.7719 5.26459C16.4678 4.9118 15.9755 4.9118 15.6722 5.26459L10 11.8271L4.32782 5.26459C4.02372 4.9118 3.5314 4.9118 3.22808 5.26459C2.92397 5.61557 2.92397 6.18434 3.22808 6.53712L9.45013 13.7368Z"}
        fill="#4A4A4A" stroke="#4A4A4A" />
    </svg>
  );
};

export default IconDropdownArrow;
